// TransferReceiptModal.jsx
import React, { useState } from 'react';
import PDFViewer from '../../Common/PDFViewer';
import JSONViewer from '../../JSONViewer'; // Asegúrate de importar tu componente JSONViewer
import { resolveBedrockMetadata } from '../../../utils/bedrockNormalize';
import './TransferReceiptModal.css';


const TransferReceiptModal = ({
  isOpen = false,
  onClose = () => { },
  transferData,
  onConciliate = () => { },
  showConciliateButton = true,
  // Props para el PDF
  getPresignedUrl,
  pdfUrl,
  s3Key,
  bucketName
}) => {
  const [isConciliating, setIsConciliating] = useState(false);
  const [activeTab, setActiveTab] = useState('details'); // 'details' o 'json'

  const data = transferData;
  console.log(data);

  const handleConciliate = async () => {
    setIsConciliating(true);
    try {
      await onConciliate(data);
      setTimeout(() => {
        setIsConciliating(false);
        onClose();
      }, 1000);
    } catch (error) {
      console.error('Error conciliating:', error);
      setIsConciliating(false);
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && !isConciliating) {
      onClose();
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  if (!isOpen) return null;

  return (
    <div className="transfer-receipt-backdrop" onClick={handleBackdropClick}>
      <div className="transfer-receipt-modal split-view">
        {/* Left Panel - Transfer Details/JSON */}
        <div className="transfer-details-panel">
          {/* Header */}
          <div className="transfer-header">
            <div className="header-content">
              <h2 className="transfer-title">Recibo de Transferencia</h2>
              <p className="transfer-id">ID: {data.transactionId}</p>
            </div>
            <button 
              className="close-button-header"
              onClick={onClose}
              disabled={isConciliating}
              aria-label="Cerrar modal"
            >
              ✕
            </button>
          </div>

          {/* Tabs Navigation */}
          <div className="transfer-tabs">
            <button
              className={`tab-button \${activeTab === 'details' ? 'active' : ''}`}
              onClick={() => handleTabClick('details')}
              disabled={isConciliating}
            >
              <span className="tab-icon">📋</span>
              Detalles
            </button>
            <button
              className={`tab-button \${activeTab === 'json' ? 'active' : ''}`}
              onClick={() => handleTabClick('json')}
              disabled={isConciliating}
            >
              <span className="tab-icon">📄</span>
              JSON
            </button>
          </div>

          {/* Tab Content */}
          <div className="transfer-content-scroll">
            {activeTab === 'details' ? (
              <>
                {/* Transfer Details */}
                <div className="transfer-section">
                  <h3 className="section-title">Detalles de la Transferencia</h3>
                  <div className="details-grid">
                    <div className="detail-item">
                      <span className="detail-label">Fecha</span>
                      <span className="detail-value">{data.date}</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-label">Monto</span>
                      <span className="detail-value amount">{data.amount}</span>
                    </div>
                  </div>
                </div>

                {/* Origin and Destination */}
                <div className="transfer-section">
                  <h3 className="section-title">Origen y Destino</h3>
                  <div className="origin-destination-container">
                    <table className="transfer-table">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Origen</th>
                          <th>Destino</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="row-label">Titular de la Cuenta</td>
                          <td className="origin-value">{data.origin.accountHolder}</td>
                          <td className="destination-value">{data.destination.accountHolder}</td>
                        </tr>
                        <tr>
                          <td className="row-label">Banco</td>
                          <td className="origin-value">{data.origin.bank}</td>
                          <td className="destination-value">{data.destination.bank}</td>
                        </tr>
                        <tr>
                          <td className="row-label">Número de Cuenta</td>
                          <td className="origin-value">{data.origin.accountNumber}</td>
                          <td className="destination-value">{data.destination.accountNumber}</td>
                        </tr>
                        <tr>
                          <td className="row-label">CUIT</td>
                          <td className="origin-value">{data.origin.cuit}</td>
                          <td className="destination-value">{data.destination.cuit}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Additional Information */}
                <div className="transfer-section">
                  <h3 className="section-title">Información Adicional</h3>
                  <div className="additional-info">
                    <div className="info-row">
                      <span className="info-label">Concepto</span>
                      <span className="info-value">{data.concept}</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">Estado</span>
                      <span className={`info-value status-\${data.status?.toLowerCase().replace(' ', '-')}`}>
                        {data.status}
                      </span>
                    </div>
                    {data.tags && (
                      <div className="info-row">
                        <span className="info-label">Etiquetas</span>
                        {data.tags && data.tags.length > 0 && (
                          <div className="invoice-tags">
                            {data.tags.map((t, i) => (
                              <span key={i} className="tag tag-quarter">
                                {t}
                              </span>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </>
            ) : (
              /* JSON Tab Content */
              <div className="transfer-section json-section">
                <h3 className="section-title">Datos JSON</h3>
                <div className="json-viewer-container">
                  <JSONViewer 
                               data={resolveBedrockMetadata(data)}
                               title="Document Data (JSON Format)"
                               height="400px"
                               downloadFileName={data.filename}
                               className="modal-json-viewer"
                             />
                </div>
              </div>
            )}
          </div>

          {/* Fixed Actions at Bottom */}
          <div className="transfer-actions">
            {showConciliateButton && (
              <button
                className="conciliate-button"
                onClick={handleConciliate}
                disabled={isConciliating}
              >
                {isConciliating ? (
                  <>
                    <span className="loading-spinner"></span>
                    Conciliando...
                  </>
                ) : (
                  'Conciliar con Estado de Cuenta'
                )}
              </button>
            )}
            <button
              className="close-button"
              onClick={onClose}
              disabled={isConciliating}
            >
              Cerrar
            </button>
          </div>
        </div>

        {/* Right Panel - PDF Viewer */}
        <div className="pdf-viewer-panel">
          <div className="pdf-panel-header">
            <h3 className="pdf-panel-title">Documento Original</h3>
          </div>
          <div className="pdf-panel-content">
            <PDFViewer
              presignedUrl={pdfUrl}
              s3Key={data.key}
              fileType={data.mimetype}
              fileName={data.filename}
              height="100%"
              showControls={false}
              showDownload={true}
              showFullscreen={true}
              className="transfer-pdf-viewer"
              refreshInterval={300000}
              maxRetries={3}
              onLoadSuccess={(info) => console.log('PDF loaded:', info)}
              onLoadError={(error) => console.error('PDF error:', error)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransferReceiptModal;